var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"link-back pl-0 pr-1",attrs:{"color":"primary","disabled":_vm.disabled,"text":""},on:{"click":_vm.goBack}},[_c('v-icon',{attrs:{"aria-hidden":"true"}},[_vm._v(" mdi-chevron-left ")]),_c('span',[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }